import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactModal from "react-modal";

import AudioCard from "../verses/AudioCard";
import Navbar from "../../components/common/Navbar";
import HeaderBar from "../../components/common/HeaderBar";

import { FaBookmark, FaShareAlt } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { getJournalsAction } from "../../store/Bible/BibleAction";
import { useParams } from "react-router-dom";
import LoaderSpinner from "../../components/common/LoaderSpinner";
import Toastiy from "../../components/common/Toastiy";
import { copyToClipboard } from "../../utils/Utils";
import { JOURNAL_NOTE_ITEM_TYPES } from "../../constants/common";

const JournalDetails = () => {
  const dispatch = useDispatch();

  const { languagePreferred } = useSelector(
    (state) => state.languageReducer.data
  );
  const { id } = useParams();

  const [popCancle, setPopCancel] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [journalDetails, setJournalDetails] = useState({});
  const [journalDetailsLoading, setJournalDetailsLoading] = useState(false);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const fetchJournals = () => {
    setJournalDetailsLoading(true);

    dispatch(
      getJournalsAction({
        apiPayloadRequest: { _id: id },
        callback: (response) => {
          setJournalDetails(response?.data?.[0]);
          setJournalDetailsLoading(false);
        },
      })
    );
  };

  useEffect(() => {
    fetchJournals();
  }, [languagePreferred]);

  useEffect(() => {
    const groupId = new URLSearchParams(window.location.search).get("groupId");
    if (id && groupId) {
      const syncProgress = async () => {
        try {
          const token = localStorage.getItem("token");
          let baseUrl = process.env.REACT_APP_BASE_URL || "";
          if (baseUrl && !baseUrl.endsWith("/")) {
            baseUrl += "/";
          }
          await fetch(`${baseUrl}groups/progress/save`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify({
              groupObjId: groupId,
              contentType: "journal",
              contentObjId: id,
              progress: 100,
              completed: true
            })
          });
        } catch (err) {
          console.error("Error saving journal progress: ", err);
        }
      };
      syncProgress();
    }
  }, [id]);

  const thumbnail = journalDetails?.bg_Images?.find(
    (d) => d?.type_of_url === JOURNAL_NOTE_ITEM_TYPES.VIDEO
  );
  const banner = journalDetails?.banner_Images?.find(
    (d) => d?.type_of_url === JOURNAL_NOTE_ITEM_TYPES.VIDEO
  );

  return (
    <div className="flex w-full flex-col overflow-hidden md:flex-row">
      <Navbar active={"Journals"} />
      <div className="flex min-h-screen w-full flex-col md:ml-[104px]">
        <HeaderBar
          popCancle={popCancle}
          cancelBtn={!popCancle}
          cancelBtnHandle={() => setPopCancel(true)}
          tabValues={[]}
          stepBack={true}
          back={true}
          backLink="/journals"
          active={activeTab}
          handleTabChange={handleTabChange}
          getLanguagePreferred={() => {}}
          getCurrentLanguageTitles={() => {}}
        />
        <div className="flex w-full flex-1 flex-col overflow-y-auto bg-black p-8">
          {journalDetailsLoading ? (
            <div className="flex h-[60vh] w-full items-center justify-center">
              <LoaderSpinner />
            </div>
          ) : (
            <>
              <div
                className="relative aspect-[16/12] overflow-hidden rounded-t-3xl bg-cover bg-top md:aspect-[16/3]"
                style={{ backgroundImage: `url(${banner?.url_link})` }}
              >
                <div className="absolute flex h-full w-full flex-col justify-end bg-gradient-to-bl from-black/0 to-black/80 p-8">
                  <div className="absolute left-8 top-8 flex items-center gap-3.5 text-xl text-white">
                    {/* <FaBookmark /> */}
                    <FaShareAlt
                      className="cursor-pointer"
                      onClick={() => {
                        copyToClipboard(
                          `https://todaywithgod.org/journals/${journalDetails?._id}`
                        );
                        Toastiy("Copied to clipboard!", 1);
                      }}
                    />
                  </div>
                  <h3 className="text-4xl font-semibold text-white md:text-5xl">
                    {journalDetails?.journal_title}
                  </h3>
                  <span className="pb-2 text-lg text-white">
                    {journalDetails?.author ?? ""}
                  </span>
                </div>
              </div>
              <div className="w-full bg-blackishV2 p-8 text-white text-opacity-90">
                <p className="py-2">{journalDetails?.journal_description}</p>
                {journalDetails?.notes?.map((noteItem, noteIndex) => (
                  <div
                    className="custom-scrollbar flex w-full flex-1 flex-col gap-3 overflow-y-auto pb-10 pr-2"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {noteItem?.verse_start && (
                      <div className="w-full">
                        <div className="flex gap-4 py-2 text-greyish">
                          <h3 className="text-2xl font-semibold">
                            {noteItem?.bookname}{" "}
                            <span>
                              {noteItem?.chapterid}:{noteItem?.verse_start}
                            </span>
                          </h3>
                        </div>
                        <p className="text-greyish">{noteItem?.verse_text}</p>
                      </div>
                    )}
                    {noteItem?.noteitems?.map((item, noteItemIndex) => {
                      if (
                        item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VERSE
                      ) {
                        return (
                          <div
                            className="flex w-full flex-col gap-2"
                            key={`note-item${noteItemIndex}`}
                          >
                            <div className="flex gap-4 text-greyish">
                              <h3 className="text-2xl font-semibold text-white">
                                {item?.bookname}{" "}
                                <span>
                                  {item?.chapterid}:{item?.verse_start}
                                </span>
                              </h3>
                            </div>
                            <p className="text-greyish">{item?.notes}</p>
                          </div>
                        );
                      } else if (
                        item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.TEXT
                      ) {
                        return (
                          <div
                            className="w-full text-greyish"
                            key={`note-item${noteItemIndex}`}
                          >
                            <p
                              dangerouslySetInnerHTML={{ __html: item?.notes }}
                              style={{
                                minHeight: 24,
                                lineHeight: 1.7,
                              }}
                              className="rte-content"
                            />
                          </div>
                        );
                      } else if (
                        item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.IMAGE
                      ) {
                        return (
                          <div
                            className="flex w-full flex-col items-center text-greyish"
                            key={`note-item${noteItemIndex}`}
                          >
                            {item?.url_link && (
                              <>
                                <img
                                  src={item?.url_link}
                                  alt={"image" + (noteItemIndex + 1)}
                                  className="h-[70vh] w-auto cursor-pointer object-contain object-top"
                                  onClick={() =>
                                    setFullscreenImage(item?.url_link)
                                  }
                                />
                                {item?.notes && (
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: item?.notes,
                                    }}
                                    style={{
                                      minHeight: 24,
                                      lineHeight: 1.7,
                                    }}
                                    className="rte-content mb-3 text-white"
                                  />
                                )}
                              </>
                            )}
                          </div>
                        );
                      } else if (
                        item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VIDEO
                      ) {
                        return (
                          <div
                            className="flex w-full flex-col items-center text-greyish"
                            key={`note-item${noteItemIndex}`}
                          >
                            {item?.url_link && (
                              <>
                                <video
                                  src={item?.url_link}
                                  alt={"video" + (noteItemIndex + 1)}
                                  controls
                                  className="h-[70vh] w-auto border border-greyishV2 object-contain object-center"
                                />
                                {item?.notes && (
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: item?.notes,
                                    }}
                                    style={{
                                      minHeight: 24,
                                      lineHeight: 1.7,
                                    }}
                                    className="rte-content mb-3 text-white"
                                  />
                                )}
                              </>
                            )}
                          </div>
                        );
                      } else if (
                        item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.AUDIO
                      ) {
                        return (
                          <div
                            className="grid w-full grid-cols-3 gap-2 text-greyish"
                            key={`note-item${noteItemIndex}`}
                          >
                            <AudioCard url={item?.url_link} />
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      {/* Fullscreen Image Modal */}
      <ReactModal
        isOpen={!!fullscreenImage}
        onRequestClose={() => setFullscreenImage(null)}
        className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90 outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-90 z-[99999]"
        ariaHideApp={false}
      >
        <div className="relative flex h-full w-full items-center justify-center">
          <button
            className="absolute right-4 top-4 z-50 rounded-full bg-yellowish p-2 text-2xl text-blackish"
            onClick={() => setFullscreenImage(null)}
          >
            <IoMdClose alt="Close" />
          </button>
          <img
            src={fullscreenImage}
            alt="Fullscreen"
            className="mx-auto max-h-[90vh] max-w-[90vw] rounded-xl object-contain"
          />
        </div>
      </ReactModal>
    </div>
  );
};

export default JournalDetails;
